import Icons from 'images/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import Path, { CLOSE_CONFIRM_SCREENS } from 'constants/routePath';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { messageModalActions } from 'slices/messageModalSlice';

const TopIconGuest = ({ className }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;

  return (
    <div
      className={classNames('mr-2 cursor-pointer', className)}
      onClick={() => {
        if (CLOSE_CONFIRM_SCREENS.includes(pathname)) {
          dispatch(
            messageModalActions.showLeaveConfirmModalOpen({
              onClickTransition: () =>
                navigate(Path.GUEST_RESERVATION, { state: { previousStep: 0 } }),
            })
          );
        } else if (pathname === Path.GUEST_RESERVATION) {
          navigate(0);
        } else {
          navigate(Path.GUEST_RESERVATION, { state: { previousStep: 0 } });
        }
      }}
    >
      <Icons.Image
        src={Icons.logo_GuestReserve}
        className="mb-1 h-[25px] w-[192px]"
      />
      <p className="break-keep text-[14px] font-bold lg:text-[16px]">
        車買取査定ゲスト予約
      </p>
    </div>
  );
};

export default TopIconGuest;
